import { FormGroup, FormControl, AbstractControl, ValidatorFn } from "@angular/forms";


export function validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
        const loControl = formGroup.get(field);
        if (loControl instanceof FormControl) {
            loControl.markAsTouched({ onlySelf: true });
            loControl.markAsDirty({ onlySelf: true });
        } else if (loControl instanceof FormGroup) {
            //this.validateAllFormFields(loControl);
        }
    });
}

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        // if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        //     return;
        // }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

export function isSetPasswordByUser() {
    let loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    if (loCurrentUserData.isflgIsSetupPassword) {
        return true;
    }
    else {
        return false;
    }
}

export class NumberValidators {
    static isNumberCheck(): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            let number = /^[.\d]+$/.test(c.value) ? +c.value : NaN;
            if (number !== number) {
                return { 'value': true };
            }
            return null;
        };
    }
}

export function GetTimeZone() {
    //Get timezone
    // var dt = new Date();
    // if (dt != null) {
    //     var timezoneText = Date().slice(Date().indexOf("(")+1,Date().lastIndexOf(")"));;

    //    // var timezoneText = /\((.*)\)/.exec(new Date().toString())[1];
    //   //  console.log(timezoneText);

    //     switch (timezoneText.toString().toLowerCase()) {
    //         case "pacific daylight time":
    //         case "pdt":
    //         case "pst":
    //             timezoneText = "Pacific Standard Time";
    //             break;
    //         case "central daylight time":
    //         case "cdt":
    //         case "cst":
    //             timezoneText = "Central Standard Time";
    //             break;
    //         case "mountain daylight time":
    //         case "mdt":
    //         case "mst":
    //             timezoneText = "Mountain Standard Time";
    //             break;
    //         case "eastern daylight time":
    //         case "edt":
    //         case "est":
    //             timezoneText = "Eastern Standard Time";
    //             break;
    //         case "atlantic daylight time":
    //         case "adst":
    //         case "ast":
    //             timezoneText = "Atlantic Daylight Time";
    //             break;

    //         case "atlantic standard time" :
    //         case "at" :
    //         case "ast" :
    //         case "hna" :
    //             timezoneText = "Atlantic Standard Time";
    //             break;
    //         case "india standard time":
    //         case "ist":
    //             timezoneText = "Greenwich Mean Time";
    //             break;

    //         case "australian central daylight saving time":
    //         case "acdt":
    //             timezoneText = "Australian Central Daylight Saving Time";
    //             break;

    //         case "australian central standard time":
    //         case "acst":
    //         case "aedt":
    //             timezoneText = "Australian Central Standard Time";
    //             break;

    //         case "acre time":
    //         case "act":
    //             timezoneText = "Acre Time";
    //             break;

    //         case "australian central western standard time":
    //         case "acwst":
    //             timezoneText = "Australian Central Western Standard Time";
    //             break;

    //         case "australian eastern standard time":
    //         case "aest":
    //             timezoneText = "Australian Eastern Standard Time";
    //             break;

    //         case "afghanistan time":
    //         case "aft":
    //             timezoneText = "Afghanistan Time";
    //             break;

    //         case "alaska standard time":
    //         case "akst":
    //             timezoneText = "Alaska Standard Time";
    //             break;

    //         case "armenia standard time":
    //         case "amst":
    //             timezoneText = "Armenia Standard Time";
    //             break;

    //         case "argentina standard time":
    //         case "art":
    //             timezoneText = "Argentina Standard Time";
    //             break;

    //         case "arab standard time":
    //         case "arab":
    //             timezoneText = "Arab Standard Time";
    //             break;

    //         case "arabian standard time":
    //         case "arabia":
    //             timezoneText = "Arabian Standard Time";
    //             break;

    //         case "arabic standard time":
    //         case "arabic":
    //             timezoneText = "Arabic Standard Time";
    //             break;

    //         case "australian western standard time":
    //         case "awst":
    //             timezoneText = "Australian Western Standard Time";
    //             break;

    //         case "azores standard time":
    //         case "azost":
    //             timezoneText = "Azores Standard Time";
    //             break;

    //         case "azerbaijan time":
    //         case "azt":
    //             timezoneText = "Azerbaijan Time";
    //             break;

    //         case "central america standard time":
    //         case "cast":
    //             timezoneText = "Central America Standard Time";
    //             break;

    //         case "central africa time":
    //         case "cat":
    //             timezoneText = "Central Africa Time";
    //             break;

    //         case "central brazilian time":
    //         case "cbst":
    //             timezoneText = "Central Brazilian Time";
    //             break;

    //         case "central europe time":
    //         case "cet":
    //             timezoneText = "Central Europe Time";
    //             break;

    //         case "central european standard time":
    //         case "cest":
    //             timezoneText = "Central European Standard Time";
    //             break;

    //         case "caucasus time":
    //         case "ccs":
    //             timezoneText = "Caucasus Time";
    //             break;

    //         case "greenland standard time":
    //         case "cgt":
    //             timezoneText = "Greenland Standard Time";
    //             break;

    //         case "china standard time":
    //         case "chn":
    //             timezoneText = "China Standard Time";
    //             break;

    //         case "central pacific standard time":
    //         case "cpst":
    //             timezoneText = "Central Pacific Standard Time";
    //             break;

    //         case "central standard time":
    //         case "cstm":
    //             timezoneText = "Central Standard Time";
    //             break;

    //         case "cape verde time":
    //         case "cvt":
    //             timezoneText = "Cape Verde Time";
    //             break;

    //         case "dateline standard time":
    //         case "dst":
    //             timezoneText = "Dateline Standard Time";
    //             break;

    //         case "east africa time":
    //         case "eat":
    //             timezoneText = "E. Africa Standard Time";
    //             break;

    //         case "eastern standard time":
    //         case "et":
    //         case "naest":
    //         case "hne":
    //         case "est":
    //             timezoneText = "Eastern Standard Time";
    //             break;

    //         case "eastern european time":
    //         case "eet":
    //             timezoneText = "Eastern European Time";
    //             break;

    //         case "egypt standard time":
    //         case "egy":
    //             timezoneText = "Egypt Standard Time";
    //             break;

    //         case "ekaterinburg standard time":
    //         case "ekb":
    //             timezoneText = "Ekaterinburg Standard Time";
    //             break;

    //         case "south america eastern standard time":
    //         case "esast":
    //             timezoneText = "South America Eastern Standard Time";
    //             break;


    //         case "fiji standard time":
    //         case "fjt":
    //             timezoneText = "Fiji Standard Time";
    //             break;

    //         case "fle standard time":
    //         case "fle":
    //             timezoneText = "Fiji Standard Time";
    //             break;

    //         case "georgia standard time":
    //         case "get":
    //             timezoneText = "Georgia Standard Time";
    //             break;

    //         case "greenwich mean time":
    //         case "gmt":
    //             timezoneText = "Greenwich Mean Time";
    //             break;

    //         case "pakistan standard time":
    //         case "pkt":
    //             timezoneText = "Pakistan Standard Time";
    //             break;
    //         default:
    //             timezoneText = "Pacific Standard Time";
    //             break;
    //     }
    //    // console.log(timezoneText);
    //     return timezoneText;

    //    // return this.ReturnFullTimeZoneName(TimeZoneName);
    //     //return /\((.*)\)/.exec(new Date().toString())[1];
    // }
    // else {
        return ("Eastern Standard Time");
    //}
}

export function dayDifference(todayDate: any, updatedDate: any) {
  let difference = todayDate.getTime() - updatedDate?.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
}

/**
 * Copy text to clipboard - with macOS/Safari async context handling
 * Note: On macOS/Safari, clipboard access only works within user click event.
 * After async API calls, Safari blocks clipboard for security.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
    if (!text.trim()) {
        return false;
    }
    
    const textToCopy = text.trim();
    
    // Detect browser and platform
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform || navigator.userAgent);
    
    // Modern Clipboard API - works in most browsers
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(textToCopy);
            return true;
        } catch (err: any) {
            // Safari blocks clipboard after async operations (API calls)
            // This is expected security behavior on macOS
            if (isSafari && isMac && err?.name === 'NotAllowedError') {
                console.log('macOS Safari: Clipboard blocked after async operation (expected)');
                return false; // Will trigger manual copy UI
            }
        }
    }
    
    // Fallback: execCommand (works in some cases but also blocked after async on Safari)
    try {
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';
        
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        
        const success = document.execCommand('copy');
        document.body.removeChild(textarea);
        
        return success;
    } catch (err) {
        return false;
    }
}

/**
 * Detect if we're on macOS/Safari where clipboard might be blocked after async operations
 */
export function isMacOSSafari(): boolean {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isMac = /Mac/i.test(navigator.platform || navigator.userAgent);
    return isSafari && isMac;
}

/**
 * Triggers a file download from a Blob using a same-origin object URL.
 * This works consistently on Windows, macOS, and all browsers because blob: URLs
 * are same-origin, so the anchor's download attribute is always honored (unlike
 * cross-origin href URLs, which Safari/macOS ignore for security).
 */
export function downloadFromBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    try {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'download';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } finally {
        URL.revokeObjectURL(url);
    }
}

/**
 * Derives a suggested filename from a URL (path segment after last slash, or 'download').
 */
export function getFileNameFromUrl(url: string): string {
    if (!url || typeof url !== 'string') return 'download';
    const segment = url.substring(url.lastIndexOf('/') + 1);
    const trimmed = segment.split('?')[0].trim();
    return trimmed || 'download';
}

/** Path used by the dev proxy for claim files (avoids CORS when app and API run on different ports). */
const CLAIM_FILES_PATH = '/images/ClaimFiles';

/**
 * Rewrites a cross-origin claim file URL to the same-origin proxy URL when applicable.
 * Use when the API returns a URL on a different origin (e.g. localhost:63351) that does not
 * send CORS headers; the Angular proxy forwards /api/claim-files to the API's /images/ClaimFiles.
 * @param url Full URL returned by the API
 * @param apiBaseUrl Base URL of the API (e.g. environment.WebApiURL)
 * @returns Same-origin URL to use for fetch, or original url if no rewrite
 */
export function rewriteClaimFileUrlForProxy(url: string, apiBaseUrl: string): string {
    if (!url || !apiBaseUrl || typeof url !== 'string' || typeof apiBaseUrl !== 'string') return url;
    const decodedUrl = decodeURI(url);
    const base = apiBaseUrl.replace(/\/$/, '');
    const prefix = base + CLAIM_FILES_PATH;
    if (decodedUrl.startsWith(prefix + '/') || decodedUrl === prefix) {
        const pathAfter = decodedUrl.substring(prefix.length);
        const encodedPath = pathAfter.split('/').map((seg) => encodeURIComponent(seg)).join('/');
        return window.location.origin + '/api/claim-files' + encodedPath;
    }
    return url;
}

/**
 * Returns true if the URL can be fetched via our proxy (same-origin after rewrite).
 * Used when proxy.conf.json is in place to fetch API claim files without CORS.
 */
export function isClaimFileUrlRewritable(url: string, apiBaseUrl: string): boolean {
    if (!url || !apiBaseUrl || typeof url !== 'string' || typeof apiBaseUrl !== 'string') return false;
    const decodedUrl = decodeURI(url);
    const base = apiBaseUrl.replace(/\/$/, '');
    const prefix = base + CLAIM_FILES_PATH;
    return decodedUrl.startsWith(prefix + '/') || decodedUrl === prefix;
}

/**
 * Returns true if the URL has the same origin as the current page (same protocol, host, port).
 */
export function isSameOrigin(url: string): boolean {
    try {
        return new URL(url).origin === window.location.origin;
    } catch {
        return false;
    }
}

/**
 * Triggers a file download from a URL. Works with or without proxy.conf.json:
 * - Same-origin URL: fetches and downloads via blob (download attribute works on all platforms).
 * - Cross-origin URL: opens in a new tab (avoids CORS; user can save from there).
 * No proxy is required: API (e.g. localhost:63351) and S3 presigned URLs both open in a new tab.
 * @param url Full URL of the file
 * @param fileName Optional filename; if omitted, derived from URL
 * @param apiBaseUrl Optional, reserved for future proxy use; currently unused
 * @returns Promise that resolves when download was triggered or URL was opened in a new tab
 */
export function triggerDownloadFromUrl(url: string, fileName?: string, apiBaseUrl?: string): Promise<void> {
    const name = fileName != null ? fileName : getFileNameFromUrl(url);

    if (isSameOrigin(url)) {
        return fetch(url, { method: 'GET', credentials: 'include' })
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.blob();
            })
            .then((blob) => downloadFromBlob(blob, name));
    }

    window.open(url, '_blank');
    return Promise.resolve();
}